"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiSelect = getMuiSelect;
function getMuiSelect(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      select: {
        padding: '18px 16px',
        paddingRight: '32px !important'
      }
    }
  };
}